import moment from 'moment'
import store from '@/store'
import { resetRouter } from '@/router'

import loginRest from '@/rest/login'
import { getInfo } from '@/rest/user'
import { generateNewPassword } from '@/rest/users'

import { getUserSessionId, setUserSessionId, removeUserSessionId } from '@/utils/auth'
import { fetchRoleUsers } from '@/rest/roles'
import { getUserLabels } from '@/utils/user'

const state = {
  // current user info

  session: getUserSessionId(),
  id: null,
  username: '',
  name: '',
  tenant: '',
  avatar: '',
  introduction: '',
  roles: [],
  permissions: [],
  email: '',
  phone: '',

  // common info, not only for one user

  roleUsers: null
}

const mutations = {
  SET_SESSION (state, session) {
    setUserSessionId(session)
    state.session = session
  },
  REMOVE_SESSION (state) {
    removeUserSessionId()
    state.session = null
  },

  //

  SET_USER_INFO: (state, {user, userData}) => {
    state.id = user.id
    state.username = user.username
    state.tenant = user.tenant
    state.email = user.email
    state.phone = user.phone
    state.roles = user.roles

    if (userData) {
      state.akList = userData['[AIRLINE]']
      state.ports = Array.isArray(userData['[PORTS]']) ? userData['[PORTS]'] : []
      if (Array.isArray(userData['[ORGANIZATION]']) && userData['[ORGANIZATION]'].length > 0) {
        state.organizationId = +userData['[ORGANIZATION]'][0]
      } else {
        state.organizationId = null
      }
    } else {
      state.ports = []
    }
    // use language to store only one name
    let name = null
    if (user.id) {
      name = store.getters.isLanguageEn ? user.nameEn : user.name
    }
    state.name = name

    state.permissions = user.permissions
  },
  RESET_USER_INFO: (state) => {
    // NOTE: all user fields of empty object are 'undefined'
    mutations.SET_USER_INFO(state, {user: {roles: [], permissions: []}})
  },

  //

  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
  },

  // common info mutaions

  SET_ROLE_USERS: (state, {role, roleUsers}) => {
    if (state.roleUsers == null) {
      state.roleUsers = {}
    }
    state.roleUsers[role] = roleUsers
  }
}

const actions = {
  // user login
  login ({ commit }, userInfo) {
    const { dbItem, username, password, rememberme } = userInfo
    return new Promise((resolve, reject) => {
      loginRest.login(dbItem, username, password, rememberme).then(response => {
        const { user, session, userData } = response
        const passValidTo = moment((userData['[PASS_VALID_TO]'] || [])[0], 'DD.MM.YYYY')
        if (passValidTo.isValid() && moment().isAfter(passValidTo)) {
          generateNewPassword(user.id)
          reject({response: {data: {message: 'AuthenticationError.passwordExpired'}}})
        } else {
          document.MeridianVue.debug && console.log('login user: %o, session: %o, userData: %o', user, session, userData)
          commit('SET_SESSION', session['JSESSIONID'])

          commit('SET_USER_INFO', {user, userData})
          resolve(user)
        }
      }).catch(error => {
        console.log('login error: %o', error)
        reject(error)
      })
    })
  },

  // get user info
  getInfo ({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const { session, user, userData } = response
        if (!session || !user) {
          reject(new Error('Verification failed, please Login again.'))
        }

        const { name, roles, permissions } = user

        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject(new Error('getInfo: roles must be a non-null array!'))
        }

        // update session if rememberme was triggered
        commit('SET_SESSION', session)

        commit('SET_USER_INFO', {user, userData})
        // commit('SET_NAME', name)
        // commit('SET_ROLES', roles)
        // commit('SET_PERMISSIONS', permissions)

        // commit('SET_AVATAR', avatar)
        // commit('SET_INTRODUCTION', introduction)
        resolve(user)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout ({ commit, state }) {
    console.log('logout user')
    return new Promise((resolve, reject) => {
      loginRest.logout().then((response) => {
        document.MeridianVue.debug && console.log('logout response: %o', response)
        commit('REMOVE_SESSION')

        commit('RESET_USER_INFO')
        // commit('SET_INFO', '')
        // commit('SET_ROLES', [])
        // commit('SET_PERMISSIONS', [])
      }).then(() => {
        resetRouter()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove session
  resetSession ({ commit }) {
    return new Promise(resolve => {
      commit('REMOVE_SESSION')
      commit('SET_INFO', '')
      commit('SET_ROLES', [])
      commit('SET_PERMISSIONS', [])
      resolve()
    })
  },

  /**
   * update and store users by role.
   * Note: used to retrieve initiators and may be extracted and moved to a "flight-order" module in the future
   */
  updateRoleUsers ({ commit, state }, role) {
    return new Promise(async (resolve, reject) => {
      // XXX: do we need store result or request users always when calls this action?
      const language = store.getters.getLanguage
      const roleUsers = await fetchRoleUsers(role)

      roleUsers.forEach(u => {
        u.labels = getUserLabels(u, language)
      })
      commit('SET_ROLE_USERS', {role, roleUsers})
      resolve(state.roleUsers[role])
    })
  }

  /*
  // Dynamically modify permissions
  changeRoles ({ commit, dispatch }, role) {
    return new Promise(async resolve => {
      const token = role + '-token'

      commit('SET_INFO', token)

      const { roles } = await dispatch('getInfo')

      resetRouter()

      // generate accessible routes map based on roles
      const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })

      // dynamically add accessible routes
      router.addRoutes(accessRoutes)

      resolve()
    })
  }
  */
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js